import { render, staticRenderFns } from "./VueBookMenu.vue?vue&type=template&id=a008a0be&"
import script from "./VueBookMenu.vue?vue&type=script&lang=ts&"
export * from "./VueBookMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VueBookMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\2-Projects\\1-asva\\5-vue-book\\1-vue-book\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a008a0be', component.options)
    } else {
      api.reload('a008a0be', component.options)
    }
    module.hot.accept("./VueBookMenu.vue?vue&type=template&id=a008a0be&", function () {
      api.rerender('a008a0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\components\\DemoPage\\VueBookMenu.vue"
export default component.exports